import Raven from 'raven-js';
import { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { Image } from 'foundations-components/transitional/components/Image';
import { FontOption } from './FontOption';
import { findWhere } from 'underscore';
import { jsx as _jsx } from "react/jsx-runtime";
class CustomFontOption extends Component {
  constructor(props) {
    super(props);
    this.onSvgError = () => {
      const {
        font,
        variant
      } = this.props;
      const {
        name
      } = font || {};
      Raven.captureMessage('Missing valid Custom font SVG', {
        extra: {
          name,
          variant
        }
      });
      this.setState({
        useFallback: true
      });
    };
    this.state = {
      useFallback: false
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  renderFallback() {
    const {
      font,
      variant
    } = this.props;
    const {
      name
    } = font || {};
    if (variant) {
      return /*#__PURE__*/_jsx("span", {
        children: variant
      });
    }
    return /*#__PURE__*/_jsx(FontOption, {
      fontFamily: name,
      children: name
    });
  }
  render() {
    const {
      font,
      variant
    } = this.props;
    const {
      defaultSvgUrl,
      variants = []
    } = font;
    let svgUrl = defaultSvgUrl;
    if (variant) {
      const variantData = findWhere(variants, {
        name: variant
      });
      svgUrl = variantData && variantData.svgUrl;
    }
    if (this.state.useFallback || !svgUrl) {
      return this.renderFallback();
    }
    return /*#__PURE__*/_jsx(Image, {
      onError: this.onSvgError,
      src: svgUrl
    });
  }
}
export default CustomFontOption;